


























import { Component, Vue, Prop, Watch, Inject } from "vue-property-decorator";
import { DataPoint, HSL, Name, NameData } from "../models";
import { paletteGenerator } from "../utils/paletteGenerator";
import {
  mdiDiceMultiple,
  mdiCheckCircleOutline,
  mdiCloseCircleOutline,
  mdiAccountCircle
} from "@mdi/js";
import GenderIcon from "../components/GenderIcon.vue";
import NameCard from "../components/NameCard.vue";
import VueSwing from "vue-swing/VueSwing.vue";

@Component({
  components: {
    GenderIcon,
    NameCard,
    VueSwing
  },
  mounted() {
    fetch(`${process.env.VUE_APP_API_ROOT}/minmax-years`)
      .then(res => res.json())
      .then((data: any) => {
        const { minYear, maxYear } = data;
        this.$data.minYear = minYear;
        this.$data.maxYear = maxYear;
      });
  }
})
export default class NameDeck extends Vue {
  @Prop({ default: [] }) names!: NameData[];

  get currentName(): NameData | null {
    return this.names[0] || null;
  }

  get cardWidth() {
    if (!this.$el) return null;
    const cardEl = this.$el.querySelector(".deck-item");
    return cardEl.getBoundingClientRect().width;
  }

  minYear = 2010;
  maxYear = 2015;

  throwConfig = {
    throwOutDistance: () => 10000,
    throwOutConfidence: (xOffset: number, yOffset: number, element: any) => {
      const xConfidence = Math.min(
        Math.abs(xOffset * 3) / element.offsetWidth,
        1
      );
      const yConfidence = Math.min(
        Math.abs(yOffset * 3) / element.offsetHeight,
        1
      );

      return Math.max(xConfidence, yConfidence);
    }
  };

  accept() {
    // send accept to server
    const name: Name = this.currentName![0]!;
    this.$emit("accept", name);
  }

  reject() {
    const name: Name = this.currentName![0]!;
    this.$emit("reject", name);
  }

  getMoreNameData() {
    this.$emit("getMoreNameData", 5);
  }
}
